import type { PrintTheme } from './types'

const PRINT_THEMES: PrintTheme[] = (
  [
    ['Podstawowy', 'kcalmar'],
    ['Liść', 'leaf'],
    ['Świąteczny Śnieżki', 'holiday_one'],
    ['Świąteczny Renifer', 'holiday_two'],
    ['Świąteczny Klasyczny', 'holiday_three'],
    ['Wielkanoc', 'easter'],
    ['Wielkanoc Druk', 'easter_print'],
    ['Wiosna Pierwszy', 'spring_one'],
    ['Wiosna Drugi', 'spring_two'],
    ['Wiosna Drugi Druk', 'spring_two_print'],
    ['Jesień', 'autumn'],
    ['Banan', 'banan'],
    ['Owoce i Warzywa Pierwszy', 'friuts_and_vegetables_one'],
    ['Owoce i Warzywa Drugi', 'friuts_and_vegetables_two'],
    ['Owoce i Warzywa Trzeci', 'friuts_and_vegetables_three'],
    ['Złota ramka', 'gold_frame'],
    ['Złota ramka kwiaty', 'gold_frame_flowers'],
    ['Złota ramka liście', 'gold_frame_leafs'],
    ['Kwiat koniczyny', 'clover_flower'],
    ['Vege', 'vege'],
    ['Dla dzieci', 'for_kids'],
    ['Duża czcionka', 'vision_deffect'],
    ['Minimal Szary', 'minimal_grey'],
    ['Minimal Zielony', 'minimal_green'],
    ['Minimal Różowy', 'minimal_pink'],
    ['Śródziemnorski', 'mediterranean'],
    ['Dla sportowca', 'for_sport'],
    ['Rysunki Niebieski', 'rysunki_blue'],
    ['Rysunki Zielony', 'rysunki_green'],
    ['Rysunki Żółty', 'rysunki_yellow'],
    ['Pixel Czerwony', 'pixel_red'],
    ['Pixel Pomarańczowy', 'pixel_orange'],
    ['Pastelowy', 'pastel'],
    ['Pixel Zielony', 'pixel_green'],
    ['Kosmos', 'cosmos'],
    ['Deseń Zielony', 'design_green'],
    ['Deseń Różowy', 'design_pink'],
    ['Składniki Kursywa', 'ingredient_italic'],
    ['Składniki Pogrubione', 'ingredient_bold'],
  ] satisfies [string, string][]
).map(([label, id]) => ({ id, label }))

export function getPrintThemes(hasPerm: (permission: string) => boolean): PrintTheme[] {
  const hasPremiumTemplates =
    hasPerm('accounts.print_template_11') || hasPerm('accounts.print_template_10')
  const limit = hasPerm('accounts.print_template_15')
    ? 39
    : hasPremiumTemplates
      ? 35
      : hasPerm('accounts.print_template_5')
        ? 26
        : 19
  const themes = PRINT_THEMES.slice(0, limit)
  if (hasPerm('accounts.diet_nfz')) {
    themes.push(
      { id: 'nfz_leaf_top', label: 'NFZ Liść Góra' },
      { id: 'nfz_leaf_contour', label: 'NFZ Liść Kontur' },
      { id: 'nfz_fruits', label: 'NFZ Owoce' },
    )
  }
  return themes
}
